import { Route } from 'types/route.type';
import SiteProfiles from './site-profiles';

export const routes: Route[] = [
  {
    path: '/profiles-strategies/site/:globalSiteId?',
    component: SiteProfiles,
    id: 'profilesStrategies.navigation.editSiteProfiles',
  },
];
